import {
  IContractBook,
  SupportedChainId,
  keyringContractAbi,
} from "@eulerxyz/core-sdk"
import { ContractFunctionConfig } from "@eulerxyz/evc-sdk"
import { BaseTransactionFactory } from "./BaseTransactionFactory"
import {
  KeyringTransactionItem,
  TransactionItemUnion,
  isKeyringTransactionItem,
} from "./types"

export class KeyringTransactionFactory extends BaseTransactionFactory {
  keyringAbi: typeof keyringContractAbi
  customData: {
    [key: string]: any
  }

  constructor(chainId: SupportedChainId, contractBook: IContractBook) {
    super(chainId, contractBook)
    this.keyringAbi = keyringContractAbi
    this.customData = {}
  }

  typeGuardConvertMultiple(
    _transactions: KeyringTransactionItem[],
  ): ContractFunctionConfig[] {
    const contractFunctionConfigs: ContractFunctionConfig[] = []
    for (const tx of _transactions) {
      const call = this.typeGuardConvertSingle(tx)
      contractFunctionConfigs.push(call)
    }
    return contractFunctionConfigs
  }

  typeGuardConvertSingle(
    _transaction: TransactionItemUnion,
  ): ContractFunctionConfig {
    if (isKeyringTransactionItem(_transaction)) {
      return this.convertKeyring(_transaction)
    }

    throw this.errorUnsupportedTransactionType(_transaction)
  }

  convertKeyring(_transaction: KeyringTransactionItem): ContractFunctionConfig {
    return {
      functionName: "createCredential",
      abi: this.keyringAbi,
      address: _transaction.to,
      args: [
        _transaction.calldata.trader,
        _transaction.calldata.policyId,
        _transaction.calldata.chainId,
        _transaction.calldata.validUntil,
        _transaction.calldata.cost,
        _transaction.calldata.key as `0x${string}`,
        _transaction.calldata.signature as `0x${string}`,
        _transaction.calldata.backdoor as `0x${string}`,
      ],
      onBehalfOfAccount: _transaction.from,
      value: BigInt(_transaction.calldata.cost),
    }
  }
}
